import {
  AutomationActionSlackInviteToChannelDenormalized,
  IAutomationActionTemplateSlackInviteToChannel
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { joinWithCommaAndAnd } from '../../../../../../../services/enumerate';
import {
  escapeReplacements,
  LightMdToJsx
} from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { actionActorToString } from '../../shared';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummarySlackInviteToChannel = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateSlackInviteToChannel
    | AutomationActionSlackInviteToChannelDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        {a.channel.type === 'EXISTING' && (
          <LightMdToJsx>
            {t('Add **{{ participants }}** to channel **{{ channel }}**', {
              participants:
                joinWithCommaAndAnd(
                  a.pplToAdd.map((o) =>
                    actionActorToString(o, expTpl.supportingActors, t)
                  ),
                  t
                ) || 'someone',
              channel: a.channel.name
            })}
          </LightMdToJsx>
        )}
        {a.channel.type === 'NEW' && (
          <LightMdToJsx>
            {t(
              'Create a new **{{ privateOrPublic }}** channel following the naming schema **{{ namingSchema }}** and add **{{ participants }}** to it.',
              {
                privateOrPublic: a.channel.isPrivate
                  ? t('private')
                  : t('public'),
                namingSchema: escapeReplacements(a.channel.nameSchema) || 'TBD',
                participants:
                  joinWithCommaAndAnd(
                    [
                      ...a.pplToAdd.map((o) =>
                        actionActorToString(o, expTpl.supportingActors, t)
                      ),
                      ...a.channel.defaultPplEmails
                    ],
                    t
                  ) || 'someone'
              }
            )}
          </LightMdToJsx>
        )}
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
